import Link from '../../views/Dashboard';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import {push} from "connected-react-router";

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus,
  nextaction: state.shift.assessment.nextaction,
  popwindow: state.shift.status.popwindow,
  username: state.shift.auth.username,
  usersList: state.shift.assessment.usersList,
  transactions: state.shift.assessment.transactions,
  role: state.shift.auth.role,
  customersList:state.shift.assessment.customersList,
  customerid: state.shift.auth.customerid,
  stagingprojectList:state.shift.assessment.stagingprojectList,
  releasestagingprojectList:state.shift.assessment.releasestagingprojectList,
});
const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    RequestList: username => {
      dispatch(actions.RequestList(username));
    },

    NPRequestList: customer =>{
      dispatch(actions.NPRequestList(customer));
    },

    inviteUser: (firstName, lastName, email, phoneNumber,adminUsername,role) =>{
      dispatch(actions.register(firstName, lastName, email, phoneNumber,adminUsername,role));
    },

    deleteUser: (username, email, adminUsername) =>{
      dispatch(actions.unregister(username, email, adminUsername)).then(
        setTimeout(() => {window.location.reload()}, 2000)
      )
    },
    clickBackHandler: value => {
      dispatch(push(`/${locale}/shift`));
    },

    getCustomers: ()=>{
      dispatch(actions.customersList());
    },

    approvetranslation: (username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id,fun)=>{
      console.log(customerid)

      dispatch(actions.approvetranslation(username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id)).then(()=>{fun()});
    },

    approveassessment: (username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id,fun)=>{
      console.log(customerid)

      dispatch(actions.approveassessment(username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id)).then(()=>{fun()});
    },

    getStagingPrjList: (jobtype,repo,customerid,fun)=>{
      dispatch(actions.gettranslationstagingforrelease(jobtype,repo,customerid)).then(()=>fun());
    },

    deletesrccode: (customerid,repo,fun)=>{
      dispatch(actions.deletesrccode(customerid,repo)).then(()=>fun());
    }
  }
};

const Dashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/container/Dashboard/index.js